// extracted by mini-css-extract-plugin
module.exports = {"link":"StoreLinks_link__3rVtT","wrapper":"StoreLinks_wrapper__1bM0q"};